import React from "react";
import { Badge } from "@/components/ui/badge";

interface ExperimentStatusBadgeProps {
  status: string;
}

const ExperimentStatusBadge: React.FC<ExperimentStatusBadgeProps> = ({ status }) => {
  const normalized = (status || "").toLowerCase();
  switch (normalized) {
    case "active":
      return <Badge className="bg-green-500 hover:bg-green-600">Active</Badge>;
    case "completed":
      return <Badge className="bg-blue-500 hover:bg-blue-600">Completed</Badge>;
    case "draft":
      return <Badge className="bg-yellow-500 hover:bg-yellow-600">Draft</Badge>;
    default:
      return <Badge>{status}</Badge>;
  }
};

export default ExperimentStatusBadge;
